import { useState } from "react";
import Button, {
  ButtonTypes,
} from "../../../../../common/components/button/button";
import Dropdown from "../../../../../common/components/inputFields/dropdown/dropdown";
import TextField from "../../../../../common/components/inputFields/textFields/textField";
import PopupLayout from "../../../../../common/components/layouts/popupLayout/popupLayout";
import { useFormRef } from "../../../../../common/customHooks/useFormRef";
import { LoadingStatus } from "../../../../../common/enums/loadingStatus";
import { NewUserModel } from "../../../models/newUserModel";
import "./createUserPopup.scss";

export default function CreateUserPopup(props: {
  loadingStatus?: LoadingStatus;
  onSubmit?: (e: NewUserModel) => void;
  onClickClose?: () => void;
}) {
  const [userData, setUserData] = useState<NewUserModel>({} as NewUserModel);
  const { validate, textFieldRef } = useFormRef();

  return (
    <PopupLayout
      ttle="Add new user"
      buttonText="Add"
      onClickClose={props.onClickClose}
      onSubmit={() => props.onSubmit?.(userData)}
    >
      <div className="add-user-form">
        <div className="row-wrap">
          <TextField
            ref={(e) => (textFieldRef.current["username"] = e)}
            validator={(e) => (e == "" ? "required" : null)}
            title="username"
            onChange={(e) => setUserData({ ...userData, username: e })}
          />
          <TextField
            title="full name"
            ref={(e) => (textFieldRef.current["full name"] = e)}
            validator={(e) => (e == "" ? "required" : null)}
          />
        </div>
        <div className="row-wrap">
          <TextField
            title="email"
            ref={(e) => (textFieldRef.current["email"] = e)}
            onChange={(e) => setUserData({ ...userData, email: e })}
            validator={(e) => (e == "" ? "required" : null)}
          />
          <Dropdown
            ref={(e) => (textFieldRef.current["role"] = e)}
            validator={(e) => (e?.value == "" ? "required" : null)}
            onChange={(e) => setUserData({ ...userData, role: e.value })}
            options={[
              {
                value: "admin",
                label: "Admin",
              },
              {
                value: "contentWriter",
                label: "Content Writer",
              },
            ]}
            title="role"
          />
        </div>
        <TextField
          ref={(e) => (textFieldRef.current["password"] = e)}
          validator={(e) => (e == "" ? "required" : null)}
          title="password"
          isSecure
          onChange={(e) => setUserData({ ...userData, password: e })}
        />
        <TextField
          ref={(e) => (textFieldRef.current["confirm password"] = e)}
          validator={(e) =>
            e == ""
              ? "required"
              : e != undefined && e != userData.password
              ? "password not match"
              : null
          }
          title="confirm password"
          isSecure
          onChange={(e) => setUserData({ ...userData, confirmPassword: e })}
        />
      </div>
      <div className="create-user-buttons-container">
        <Button
          loadingStatus={props.loadingStatus}
          type={ButtonTypes.PRIMARY}
          text={"Confirm"}
          onClick={async () => {
            if (await validate()) props.onSubmit?.(userData);
          }}
        />
      </div>
    </PopupLayout>
  );
}
